import axios from 'axios';
import i18n from "../i18n";
import config from "../config";

let language = i18n.language;

let baseURL = config.apiUrl;

function toLocalISOString(date: Date): string {
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString().slice(0, -1);
}

function convertDatesToLocal(params: any): any {
    if (!params || typeof params !== 'object') return params;
    const result: any = {};
    for (const key of Object.keys(params)) {
        const value = params[key];
        if (value instanceof Date) {
            result[key] = toLocalISOString(value);
        } else {
            result[key] = value;
        }
    }
    return result;
}

export const AxiosApi = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        'Language': language,
    }
});

AxiosApi.interceptors.request.use(config => {
    if (config.params) {
        config.params = convertDatesToLocal(config.params);
    }
    return config;
});

AxiosApi.interceptors.response.use(resp => {
    return resp
}, err => {
    if (!err.response) return Promise.reject(err);
    if(err.response?.request.status === 0) return Promise.reject(err);
    if(err.response?.request.status === 0) return Promise.reject(err);

    const { responseURL, status } = err.response?.request;
    if(!responseURL) return Promise.reject(err);
    const isRedirect = responseURL.includes("ReturnUrl") && responseURL.includes("login");
    if (isRedirect) {
        if (status === 401) {
            window.location.replace("/login");
        }
    }
     
    return Promise.reject(err);
});

